import {
  CardElement /*useElements, useStripe */,
} from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  getCartDetailsSelector,
  getTotalPriceSelector,
  itemsInCartSelector,
  ResetCartAction,
} from "../../Reducers/AddToCartReducer";
import {
  getUserIdSelector,
  getUserNameSelector,
} from "../../Reducers/AuthenticationReducer";
import CheckoutProduct from "../CheckoutPage/CheckoutProduct";
import "./Payment.css";
import CurrencyFormat from "react-currency-format";
import { db } from "../../firebase";
import { isEmpty } from "lodash";
// import axios from "../../api/axios";

function Payment({
  cartDetails,
  userNameFromEmail,
  userId,
  itemsInCart,
  totalPrice,
  resetCart,
}) {
  // const stripe = useStripe();
  // const elements = useElements();

  const history = useHistory();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [succeeded, setSucceeded] = useState(false);
  const [orders, setOrders] = useState([]);

  // const [clientSecret, setClientSecret] = useState(true);

  /*
  useEffect(() => {
    const getClientSecret = async () => {
      const response = await axios({
        method: "post",
        url: `/payments/create?total=${totalPrice * 100}`,
      });

      setClientSecret(response.data.clientSecret);
    };
    getClientSecret();
  }, [totalPrice]);

  */

  useEffect(() => {
    db.collection("users")
      .doc(userId)
      .collection("orders")
      .orderBy("created", "desc")
      .onSnapshot((snapshot) =>
        setOrders(
          snapshot.docs.map((doc) => ({
            id: doc.id,
          }))
        )
      );
  }, [userId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (disabled) return alert("Please provide the card details");

    setProcessing(true);

    setTimeout(() => {
      console.log("userId", userId);

      let paymentId = 0;
      setSucceeded(true);
      setProcessing(false);
      setError(null);

      if (!isEmpty(orders)) {
        paymentId = Number(orders[0].id) + 1;
      }
      db.collection("users")
        .doc(userId)
        .collection("orders")
        .doc(`${paymentId}`)
        .set({
          cartDetails: cartDetails,
          amount: totalPrice * 100,
          created: Date.now(),
        });

      resetCart();
      history.replace("/orders");
    }, 2500);

    // await stripe
    //   .confirmCardPayment(clientSecret, {
    //     payment_method: {
    //       card: elements.getElement(CardElement),
    //     },
    //   })
    //   .then(({ paymentIntent }) => {
    //     setSucceeded(true);
    //     setProcessing(false);
    //     setError(null);

    //     db.collection("users")
    //       .doc(userId)
    //       .collection("orders")
    //       .doc(paymentIntent.id)
    //       .set({
    //         cartDetails: cartDetails,
    //         amount: paymentIntent.amount,
    //         created: paymentIntent.created,
    //       });

    //     resetCart();
    //     history.replace("/orders");
    //   });
  };

  const handleChange = (e) => {
    console.log(e);
    setDisabled(e.empty);
    setError(e.error ? e.error.message : "");
  };

  return (
    <div className="payment">
      <div className="payment__container">
        <h1>
          Checkout (<Link to="/checkout">{itemsInCart} items</Link>)
        </h1>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Delivery Address</h3>
          </div>
          <div className="payment_address">
            <p>{userNameFromEmail || "Guest"}</p>
            <p>123 React Practice</p>
            <p>India</p>
          </div>
        </div>

        <div className="payment__section">
          <div className="payment__title">
            <h3>Review Items and Delivery</h3>
          </div>
          <div className="payment__items">
            {cartDetails.map(
              ({ id, title, price, image, rating, quantity }) => (
                <CheckoutProduct
                  id={id}
                  title={title}
                  price={price}
                  image={image}
                  rating={rating}
                  quantity={quantity}
                />
              )
            )}
          </div>
        </div>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Payment Method</h3>
          </div>
          <div className="payment__details">
            <form onSubmit={handleSubmit}>
              <CardElement onChange={handleChange} />
              <div className="payment__priceContainer">
                <CurrencyFormat
                  renderText={(value) => <h3>Order Total: {value}</h3>}
                  decimalScale={2}
                  value={totalPrice}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
                <button disabled={processing || succeeded}>
                  <span>{processing ? "Processing" : "Buy Now"}</span>
                </button>
              </div>
              {error && <div>{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    itemsInCart: itemsInCartSelector(state),
    cartDetails: getCartDetailsSelector(state),
    userNameFromEmail: getUserNameSelector(state),
    totalPrice: getTotalPriceSelector(state),
    userId: getUserIdSelector(state),
  }),
  {
    resetCart: ResetCartAction,
  }
)(Payment);
